import { call, put, apply } from 'redux-saga/effects';
import Http from '../../libs/Http';
import Auth from '../../libs/Auth';
import config from '../../../../config';

export function* submitLogin(action) {
  const { payload, meta } = action;
  const redirectUrl = meta && meta.redirectUrl;
  yield put({
    type: 'SUBMITTING_LOGIN',
    payload,
    meta
  });

  yield call(Auth.removeToken);
  let data;
  try{
    data = yield call(Http.post, '/users/login', {
      body: {
        ...action.payload,
      }
    });
  }catch(error){
    if (error.name === 'HttpNotAuthorizedError') {
      yield put({
        type: 'ERROR',
        error: true,
        payload: error
      });
    } else {
      throw error;
    }
  }

  if(data){
    yield put({
      type: 'SUBMITTED_LOGIN',
      payload: {
        ...data.payload,
        token: data.headers['set-auth-token']
      }
    });
    if (config.appEnvironment === 'plugin') {
      yield apply(meta.history, meta.history.replace, ['/']);
    } else if (!data.payload.multiFactorEnabled) {
      yield apply(meta.history, meta.history.replace, ['/workArea/myAccount']);
    }else {
      yield apply(meta.history, meta.history.replace, [redirectUrl]);
    }
  }

}

export function* logout(action) {
  const { payload, meta } = action;
  Auth.removeToken();
  yield apply(meta.history, meta.history.replace, ['/']);


}


export default function*({ takeFirst }) {
  yield [
    takeFirst('SUBMIT_LOGIN', submitLogin),
    takeFirst('LOGOUT', logout),
  ];
}



// WEBPACK FOOTER //
// ./src/app/state/sagas/auth.sagas.js